import {createEntityService} from 'utils/createEntityService';
import {Location} from 'types/location';

export const LocationService = createEntityService<Location>({
  baseUrl: 'api/v1/locations',
  entityName: 'location',
});
